import { mediaQueries, palette } from '@centivo/react-components'
import styled from 'styled-components'

export const Navlist = styled.ul`
  display: flex;
  font-size: 1rem;
  font-weight: 600;

  a {
    cursor: pointer;
    line-height: 1.5rem;
    color: ${palette.brand.newPurple};

    > p {
      margin-top: 0;
    }

    &:hover,
    &:visited {
      color: ${palette.brand.newPurple};
      outline: none;
      border-bottom: 1px solid currentColor;
      margin-bottom: -1px;
    }

    &:active,
    &:focus {
      color: ${palette.brand.newPurple};
      outline: none;
      border-bottom: 4px solid currentColor;
      margin-bottom: -4px;
    }

    svg {
      font-size: 1.25rem;
      vertical-align: middle;
      margin-right: 0.5rem;
    }
  }

  & li:not(:last-child) {
    margin-right: 3rem;
  }

  @media ${mediaQueries.mobile} {
    position: fixed;
    display: flex;
    flex-direction: column;
    padding: 1.5rem 0;
    min-width: 20rem;
    min-height: 100vh;
    background-color: ${palette.neutral.white};
    padding-top: 5.25rem;
    font-size: 1.25rem;

    & li,
    & a {
      display: block;
      width: 100%;
      height: 3.5rem;
      line-height: 3.5rem;
      -webkit-tap-highlight-color: transparent;
    }

    & a {
      padding-left: 1.5rem;

      &:hover,
      &:visited,
      &:active,
      &:focus {
        color: ${palette.brand.pink};
        outline: none;
        border-bottom: unset;
        margin-bottom: unset;
        background-color: ${palette.neutral['grey-f6f7fa']};
      }

      & svg {
        font-size: 1.5rem;
        vertical-align: middle;
        margin-right: 0.75rem;
      }
    }
  }
`
